import { useDynamicForm } from "@/components/dynamic-form/hook/useDynamicForm";
import { enhanceEndTime } from "@/components/dynamic-form/formatter/enhanceEndTime";
import { getInitialValues } from "@/components/dynamic-form/helper/getInitialValues";
import { DynamicForm } from "@/components/dynamic-form";
import { useWatchPagination } from "@/components/dynamic-form/hook/useWatchPagination";
import { Table } from "@renderbus/ui";
import { columns } from "./config/desktop-table-columns";
import { useTranslation } from "react-i18next";
import { OperationButton } from "@/components/operation-button";
import { Modal } from "@/components/renderbus-modal";
import { OperationArea, SearchAreaWrapper } from "../../components/atom";
import { ExportBillForm } from "@/pages/consumption/components/export-form/export-bill-form";
import { useExportBill } from "../../hooks/useExportBill";
import { useConsumeStore } from "../../store/ConsumeStore";
import { BillTabTypeEnum } from "../../constants";
import { useEffect } from "react";
import { TableContainer } from "@/components/table-container";
import { useDesktopSearchConfig } from "./hooks/useDesktopSearchConfig";

export function DesktopOverview() {
  const { activeKey } = useConsumeStore();
  const {
    form,
    tableData,
    fetchData,
    getSearchParams,
    pageNum,
    setPageNum,
    total,
    pageSize,
  } = useDynamicForm({
    api: "/api/rendering/user/cloudProduction/getUserCloudProductionMonthBillBriefs",
    defaultPageSize: 10,
    formatter: {
      time: enhanceEndTime,
    },
  });

  useWatchPagination(pageSize, pageNum, fetchData);

  const { searchConfig } = useDesktopSearchConfig();

  const { t } = useTranslation("center");

  const { openModal, setModal, exportForm, onOk } = useExportBill({
    api: "/api/rendering/task/export/exportCloudProductionBrief",
    searchParams: getSearchParams({ hiddenPageSize: true }),
  });

  useEffect(() => {
    if (activeKey === BillTabTypeEnum.ConsumerOverview) {
      fetchData();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeKey]);

  return (
    <TableContainer noGap>
      <SearchAreaWrapper>
        <DynamicForm
          initialValues={getInitialValues(searchConfig)}
          searchConfig={searchConfig}
          searchForm={form}
          onSearch={() => fetchData()}
          showButtonIcon
        />
        <OperationArea>
          <OperationButton
            text={t("consumption_export")}
            onClick={() => setModal(true)}
          />
        </OperationArea>
      </SearchAreaWrapper>

      <Table
        paginationCurrent={pageNum}
        columns={columns}
        dataSource={tableData}
        gap={false}
        total={total}
        defaultPageSize={pageSize}
        onPageNumChange={async (num: number) => {
          setPageNum(num);
        }}
      />

      <Modal
        title={t("user_consume_pick_output_dialog_title")}
        open={openModal}
        onOk={() => {
          onOk();
        }}
        onCancel={() => {
          setModal(false);
          exportForm.setFieldValue("exportName", "");
          exportForm.resetFields();
        }}
      >
        <ExportBillForm form={exportForm} />
      </Modal>
    </TableContainer>
  );
}
